import React from 'react';
import ClientsPage from './ClientsPage';

/**
 * Page des Cabinets SNC
 * Réutilise ClientsPage avec un filtre sur contact_types = "snc"
 */
const CabinetsSNCPage = () => {
  return <ClientsPage filterType="snc" />;
};

export default CabinetsSNCPage;
